module.exports = __webpack_public_path__ + "img/I2C_Fig11.028fcc9d.png";